import { Injectable, inject } from '@angular/core';
import { CoreStore } from '@qtek/libs/store';
import { Observable } from 'rxjs';

@Injectable()
export class HideLoaderGuard {
  private coreStore = inject(CoreStore);

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    this.coreStore.closeLoading();
    return true;
  }
}
